import util from "../util/util";

export default class PolicyService {
    addRecord(payload) {
        return util
            .sendApiRequest("/policy", "POST", true, payload)
            .then((response) => {
                return response;
            })
            .catch((err) => {
                throw err;
            });
    }
    listAll(data) {
        const activity = Object.keys(data).reduce((object, key) => {
            if (data[key] !== "") {
                object[key] = data[key];
            }
            return object;
        }, {});

        return util.sendApiRequest("/policy/list", "POST", true, activity).then(
            (response) => {
                return response;
            },
            (error) => {
                throw error;
            }
        );
    }
    listAllTitle(data) {
        const activity = Object.keys(data).reduce((object, key) => {
            if (data[key] !== "") {
                object[key] = data[key];
            }
            return object;
        }, {});

        return util.sendApiRequest("/policy/list_title", "POST", true, activity).then(
            (response) => {
                return response;
            },
            (error) => {
                throw error;
            }
        );
    }
    getDetails(dataId) {
        return util
            .sendApiRequest("/policy/" + dataId, "GET", true)
            .then((response) => {
                return response;
            })
            .catch((err) => {
                throw err;
            });
    }
    editRecord(payload) {
        return util.sendApiRequest("/policy", "PUT", true, payload).then(
            (response) => {
                return response;
            },
            (error) => {
                throw error;
            }
        );
    }
    deleteRecord(dataId) {
        return util.sendApiRequest("/policy/" + dataId, "DELETE", true).then(
            (response) => {
                return response;
            },
            (error) => {
                throw new Error(error);
            }
        );
    }
}
